import { render, staticRenderFns } from "./SobreCompraDireta.vue?vue&type=template&id=0772380f&scoped=true"
import script from "./SobreCompraDireta.vue?vue&type=script&lang=js"
export * from "./SobreCompraDireta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772380f",
  null
  
)

export default component.exports